import { Helmet } from "react-helmet-async";
import AdSlot from "@/components/ads/AdSlot";

export default function About() {
  const title = "About HeightPercentile.com";
  const description = "Learn about HeightPercentile.com and how we estimate U.S. adult height percentiles.";
  const url = (typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/about";

  const breadcrumbLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: (typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/" },
      { "@type": "ListItem", position: 2, name: "About", item: url },
    ],
  };

  return (
    <main className="container mx-auto py-10 space-y-6">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={(typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/og-default.jpg"} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={(typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/og-default.jpg"} />
        <script type="application/ld+json">{JSON.stringify(breadcrumbLd)}</script>
      </Helmet>

      <AdSlot slot="banner_top" className="mb-4" />
      <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_300px]">
        <article className="min-w-0">
          <h1>{title}</h1>
          <AdSlot slot="incontent_1" className="my-4" />
          <section className="prose prose-slate dark:prose-invert max-w-none">
            <p>
              HeightPercentile.com provides a fast, accessible way to estimate adult height percentiles in the United States.
              We reference CDC/NHANES data and show clear, concise explanations of the results.
            </p>
            <p>
              For methods and data details, see our <a className="underline" href="/methodology">Methodology</a> page.
            </p>
          </section>
        </article>
        <aside className="hidden lg:block">
          <AdSlot slot="sidebar_1" />
        </aside>
      </div>
    </main>
  );
}
